var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93823 8.85394L11.8867 4.72341C11.9435 4.60387 12.0307 4.50333 12.1386 4.43306C12.2466 4.36278 12.371 4.32556 12.498 4.32556C12.6249 4.32556 12.7493 4.36278 12.8573 4.43306C12.9653 4.50333 13.0525 4.60387 13.1092 4.72341L15.0577 8.85394L19.4137 9.52026C19.5394 9.5386 19.6576 9.59375 19.7549 9.67943C19.8522 9.7651 19.9246 9.87784 19.964 10.0048C20.0033 10.1317 20.0079 10.2677 19.9774 10.3973C19.9468 10.5269 19.8822 10.6448 19.791 10.7376L16.6395 13.9508L17.3835 18.4903C17.4787 19.0729 16.8937 19.5166 16.3935 19.2419L12.498 17.0976L8.60173 19.2419C8.10223 19.5174 7.51723 19.0729 7.61248 18.4895L8.35648 13.95L5.20498 10.7368C5.11422 10.644 5.05003 10.5262 5.0197 10.3968C4.98938 10.2675 4.99414 10.1318 5.03343 10.0051C5.07273 9.87846 5.14499 9.76596 5.24201 9.68039C5.33902 9.59482 5.4569 9.53962 5.58223 9.52105L9.93823 8.85394Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgStar;